import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "entryInformation" */ './index'),
  loading: () => null,
});
